import React from "react";
import BoardButton from "../BoardButton/BoardButton";
import "./BoardEmptyState.scss";

const BoardEmptyState = ({
  icon = "📋",
  title = "Nothing here yet",
  description,
  actionLabel,
  onAction,
  className = "",
}) => (
  <div className={`pb-empty ${className}`.trim()}>
    <div className="pb-empty__icon" aria-hidden="true">{icon}</div>
    <h3 className="pb-empty__title">{title}</h3>
    {description && <p className="pb-empty__text">{description}</p>}
    {actionLabel && onAction && (
      <BoardButton variant="primary" onClick={onAction}>
        {actionLabel}
      </BoardButton>
    )}
  </div>
);

export default BoardEmptyState;
